import { ShieldAlert, Headset, FileX } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { Stagger, StaggerItem } from "@/components/motion/Reveal";
import { MANIFESTO } from "@/data/content";

const ICONS = { ShieldAlert, Headset, FileX };

export const Manifesto = () => (
  <section className="relative py-20 lg:py-28 bg-brand-navy overflow-hidden" data-testid="manifesto-section">
    <div className="absolute inset-0 bg-dotgrid opacity-50" />
    <div className="relative container-x">
      <SectionHeading
        light
        eyebrow="Why families choose us"
        title={<>Three things every other <span className="text-brand-red">provider gets wrong.</span></>}
        sub="We built LifeButton around the moments that actually matter — the fall you can't call for, the operator who answers, and the freedom to leave whenever you want."
      />

      <Stagger className="mt-14 grid gap-8 lg:grid-cols-3" gap={0.12}>
        {MANIFESTO.map((m) => {
          const Icon = ICONS[m.icon];
          return (
            <StaggerItem key={m.n}>
              <div
                data-testid={`manifesto-${m.n}`}
                className="group relative h-full rounded-3xl bg-white/[0.04] border border-white/10 p-8 hover:bg-white/[0.07] transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <span className="font-display font-black text-6xl text-white/10 leading-none group-hover:text-brand-red/40 transition-colors">
                    {m.n}
                  </span>
                  <span className="grid place-items-center w-14 h-14 rounded-2xl bg-brand-red shadow-red">
                    <Icon className="w-7 h-7 text-white" strokeWidth={2.2} />
                  </span>
                </div>
                <h3 className="mt-6 font-display font-bold text-2xl text-white leading-tight">
                  {m.title}
                </h3>
                <p className="mt-4 text-white/70 leading-relaxed">{m.body}</p>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  </section>
);
